export const UNLAYER_DEFAULT_FORM_URL = 'https://financeinsights.net/thankyou/';
